import axios, { AxiosInstance } from 'axios';

// С proxy (npm start) — запросы на тот же origin, cookie работают
// Без proxy — REACT_APP_API_URL=http://localhost:5003
const API_BASE_URL =
  process.env.REACT_APP_API_URL !== undefined && process.env.REACT_APP_API_URL !== ''
    ? process.env.REACT_APP_API_URL
    : '';

export const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
  withCredentials: true,
});

const readCookie = (name: string) => {
  const prefix = `${name}=`;
  const cookie = document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix));
  return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : '';
};

apiClient.interceptors.request.use((config) => {
  const method = (config.method || 'get').toUpperCase();
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) {
    const token = readCookie('leadops_csrf');
    if (token) {
      config.headers.set('X-CSRF-Token', token);
    }
  }
  return config;
});

export default apiClient;
